export const ingredientBasedRecipe =
  '/recipes/getRecipesWithIngredients/{ingredients}/{mealType}/{difficulty}?';
